import React from "react";
import { PortableText } from "@portabletext/react";
import DescItem from "./DescItem";

// Each field renders blocks + links with classNames matching its container's
// scoped CSS — `.item-title .title-link` for EN, `.item-sub-title .sub-title-link`
// for JP. The font class on the inner <p> mirrors the pattern from
// ArticleItem.js (PortableText's default <p> doesn't inherit font reliably
// through Tailwind preflight, so each block gets the class explicitly).
const makeComponents = (fontClass, linkClassName) => ({
  block: {
    normal: ({ children }) => <p className={fontClass}>{children}</p>,
  },
  marks: {
    link: ({ value, children }) => (
      <a href={value?.href} className={linkClassName}>
        {children}
      </a>
    ),
  },
});

const enComponents = makeComponents("font-lexend-bold", "title-link");
const jpComponents = makeComponents("font-kleeone", "sub-title-link");

const AboutItemSection = ({ item }) => {
  return (
    <div className="about-item-section">
      <div className="item-title font-lexend-bold">
        <PortableText value={item.en} components={enComponents} />
      </div>
      <div className="item-sub-title font-kleeone">
        <PortableText value={item.jp} components={jpComponents} />
      </div>
      <hr className="top-hr" />
      {(item.items || []).map((quote, key) => (
        <DescItem key={key} component={quote.text} />
      ))}
      <hr className="bottom-hr" />
    </div>
  );
};

export default AboutItemSection;
